import React from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Nav from "./nav";
import LanguageSelected from "../../../components/language-selected";
import { getStoredWorkspace } from "../../../api/workspace";
import { matchIsTextEmpty } from "../../../utils/string";

export default function CarouselGenerator() {
  const { state } = useLocation();
  const { postContent } = state || {};
  const navigate = useNavigate();

  const [carouselText, setcarouselText] = React.useState("");

  return (
    <div className="px-4 py-6 sm:px-6">
      <div className="space-y-2 sm:space-y-8">
        <div className="flex flex-col justify-between gap-4 sm:gap-6 sm:flex-row sm:items-center">
          <div>
            <h1 className="text-xl font-semibold text-gray-900 sm:text-2xl">
              Carousel Maker
            </h1>

            <p className="mt-1 text-sm font-normal text-gray-500">
              Design high-performing LinkedIn carousel posts in minutes.
            </p>
          </div>
        </div>

        <div>
          <Nav
            hideSavedCarousels={
              postContent != null &&
              postContent !== undefined &&
              postContent !== ""
            }
          ></Nav>

          <div className="mt-10">
            <h2 className="text-xl font-semibold text-gray-900">
              Generate Carousel from Text
            </h2>
            <p className="mt-1 text-sm font-normal text-gray-900">
              Use the power of AI to generate carousel from text
            </p>
            <p className="mt-1">
              <LanguageSelected></LanguageSelected>
            </p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="mt-4 space-y-4"
            >
              <div>
                <label htmlFor="carouselText" className="sr-only">
                  Carousel Text
                </label>
                <div>
                  <textarea
                    name="carouselText"
                    id="carouselText"
                    className="block w-full py-2 text-gray-900 border-0 shadow-sm resize-y rounded-xl ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 caret-blue-500"
                    rows="6"
                    placeholder="Write your text here..."
                    spellCheck="false"
                    value={carouselText}
                    onChange={(e) => setcarouselText(e.target.value)}
                  ></textarea>
                </div>
              </div>

              <button
                type="button"
                disabled={matchIsTextEmpty(carouselText)}
                onClick={() => {
                  if (matchIsTextEmpty(carouselText)) {
                    return;
                  }
                  const currentWorkspaceId = getStoredWorkspace();
                  navigate(`/ai/carousels/generate-with-ai/?workspace_id=${currentWorkspaceId}`, {
                    state: {
                      postContent: carouselText,
                    },
                  });
                }}
                className="inline-flex items-center justify-center gap-2 transition-all duration-150 rounded-full px-3 py-2 sm:px-4 sm:py-2.5 text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-500 bg-blue-500 text-white hover:bg-blue-400"
              >
                <svg
                  aria-hidden="true"
                  className="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z"
                    clipRule="evenodd"
                  />
                </svg>
                Generate Carousel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
